import React from 'react'

function withAthenaHandler(WrappedComponent) {
  class WithAthenaHandler extends React.Component {
    constructor(props) {
      super(props)

      this.state = {
        data: {
          loading: true,
          error: false,
        },
      }
    }

    componentDidMount() {
      const urlParams = new URLSearchParams(window.location.search)
      let language = urlParams.get('language')
      if (!language) {
        language = document.getElementsByTagName('html')[0].getAttribute('lang')
      }
      const languageQueryString = language ? `?language=${language}` : ''
      this.fetchData(window.zeus.settings.gatewayAPI + languageQueryString)
    }

    fetchData = async requestUrl => {
      this.setState({
        data: {
          loading: true,
          error: false,
        },
      })

      try {
        const response = await fetch(requestUrl)

        if (response.ok) {
          const data = await response.json()
          this.setState({
            data,
          })
        } else {
          throw new Error('Fetch request error')
        }
      } catch (err) {
        this.setState({
          loading: false,
          error: true,
        })
      }
    }

    render() {
      return <WrappedComponent data={this.state.data} {...this.props} />
    }
  }

  return WithAthenaHandler
}

export default withAthenaHandler
